const initialState = {
    activeMessage: null,
    isMainReplyFormOpen: true,
    isSidePanelOpen: true,
    subject: ''
};

export default initialState;
